import React, { useState, useEffect } from 'react'
import { TabBar } from 'antd-mobile'
import useRouter from '../../hooks/useRouter'
import HistoricalOrderIcon from '../Icons/HistoricalOrderIcon'
import MeIcon from '../Icons/MeIcon'
// import IndexPageIcon from '../Icons/IndexPageIcon'
import OrderIcon from '../Icons/OrderIcon'
import intl from 'react-intl-universal'

export default function BasicLayout (props) {
  const router = useRouter()
  const pages = {
    '/firstPage': '首页',
    '/register': '注册',
    '/order': '订餐',
    '/order/orderContentDetails/:id/:date/:mealType': '订餐',
    '/order/orderDefined': '订餐',
    '/historicalOrders': '订单',
    '/historicalOrders/orderMsg/:id': '订单',
    '/me': '我的'
  }
  /* 将浏览器订单的id号数字替换成:id，否则匹配路由匹配不上 */
  let newPathName = router.location.pathname
  if (newPathName.indexOf('orderMsg') !== -1) {
    newPathName = '/historicalOrders/orderMsg/:id'
  } else if (newPathName.indexOf('orderContentDetails') !== -1) {
    newPathName = '/order/orderContentDetails/:id/:date/:mealType'
  }
  // newPathName = newPathName.replace(/orderDetails\/\d+/, 'orderDetails/:id')
  const [selectedTab, setSelectedTab] = useState(pages[newPathName])
  const [hidden, setHidden] = useState(selectedTab === '首页' || selectedTab === '我的')

  let currentTab
  props.children.map((item) => {
    if (item.props.path === newPathName) {
      currentTab = item
      return true
    }
    return false
  })

  /*
   * 当用户点击首页按钮，隐藏TabBar
   */
  useEffect(() => {
    selectedTab === '首页' ? setHidden(true) : setHidden(false)
  }, [selectedTab])

  /*
   * 当用户在首页点击订餐活注册时，及时根据路由修改被选中的tab，并根据tab判断是否隐藏tabBar
   */
  useEffect(() => {
    setSelectedTab(pages[newPathName])
  }, [newPathName])

  return (
    <div style={{ position: 'fixed', width: '100%', height: '100%', top: 0, left: 0 }}>
      <TabBar
        hidden={hidden}
        tabBarPosition={'bottom'}
        prerenderingSiblingsNumber={0}
      >
        {/* <TabBar.Item
          title={intl.get('HomePage')}
          key={'首页'}
          icon={<IndexPageIcon width={18} height={18} color={'#939393'} />}
          selectedIcon={<IndexPageIcon width={18} height={18} color={'#5690FA'} />}
          selected={selectedTab === '首页'}
          onPress={() => {
            if (selectedTab !== '首页') {
              setSelectedTab('首页')
              router.history.push('/')
            }
          }}
        >
          {currentTab}
        </TabBar.Item> */}
        <TabBar.Item
          title={intl.get('Order')}
          key={'订餐'}
          icon={<OrderIcon width={22} height={22} color={'#939393'} />}
          selectedIcon={<OrderIcon width={22} height={22} color={'#5690FA'} />}
          selected={selectedTab === '订餐'}
          onPress={() => {
            if (selectedTab !== '订餐') {
              setSelectedTab('订餐')
              router.history.push('/order')
            }
          }}
        >
          {currentTab}
        </TabBar.Item>
        <TabBar.Item
          title={intl.get('Orders')}
          key={'订单'}
          icon={<HistoricalOrderIcon width={22} height={22} color={'#939393'} />}
          selectedIcon={<HistoricalOrderIcon width={22} height={22} color={'#5690FA'} />}
          selected={selectedTab === '订单'}
          onPress={() => {
            if (selectedTab !== '订单') {
              setSelectedTab('订单')
              router.history.push('/historicalOrders')
            }
          }}
        >
          {currentTab}
        </TabBar.Item>
        <TabBar.Item
          title={intl.get('Account')}
          key={'我的'}
          icon={<MeIcon width={22} height={22} color={'#939393'} />}
          selectedIcon={<MeIcon width={22} height={22} color={'#5690FA'} />}
          selected={selectedTab === '我的'}
          onPress={() => {
            if (selectedTab !== '我的') {
              setSelectedTab('我的')
              router.history.push('/me')
            }
          }}
        >
          {currentTab}
        </TabBar.Item>
      </TabBar>
    </div>
  )
}
